import Breadcrumbs from "../breadcrumbs";
import { FC, ReactNode } from "react";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

interface IDescriptionBlock {
  breadcrumbs: {
    title: string;
    url: string;
  }[];
  title: string;
  description: string;
  children?: ReactNode;
}

const DescriptionBlock: FC<IDescriptionBlock> = ({ breadcrumbs, title, description, children }) => {
  return (
    <Container>
      <div className={S.headerContent}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <div className={S.descriptionWrapper}>
          <h2 className={S.slogan}>{title}</h2>
          <p className={S.description}>
            {description} {children}
          </p>
        </div>
      </div>
    </Container>
  );
};

export default DescriptionBlock;
